module.exports = __webpack_public_path__ + "img/logo_fashion.fbc2c017.svg";